export const TANISH_GOOGLE_REVIEW_URL = "https://g.page/r/CSEsbkV9D5PxEBE/review";